<template>
    <div class="video-safety-page">
        <div class="container">
            <div class="section-title-new">
                <h1>
                    <span v-if="globalLang == ''">Сейсмобезопасность зданий</span>
                    <span v-if="globalLang == 'kz/'">Ғимараттардың сейсмикалық қауіпсіздігі</span>
                    <span v-if="globalLang == 'en/'">Seismic safety of buildings</span>
                </h1>
            </div>
            <videoItems></videoItems>
        </div>
        <!-- <div class="container container-share">
            <sharePostBottom :options="[{title: 'Поделиться данной страницей:', data_title: 'BAZIS-A | Видео', data_link: 'https://sales.bazis.kz/video', data_page: 'Видео', data_page_key: 'video'}]"></sharePostBottom>
        </div> -->
    </div>
</template>

<script>
    // import sharePostBottom from '@/components/share/share-social-bottom.vue'
    import {mapGetters} from 'vuex'
    import videoItems from '@/components/video/video-item-safety.vue'
    import store from '@/store.js'
    // import salesFilter from '@/components/realestate/sales-filter.vue'
    export default {
        name: 'news--page',
        components: {
            videoItems,
            // sharePostBottom,
        },
        data () {
            return {
                titlePage: 'Сейсмобезопасность зданий',
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            pageSetup: 'loadVideoPage',
            titleSite: 'loadSiteTitle',
            banerSystem: 'loadBanerSystem',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.videoItemsSafety.length > 0) {
                next(vm => {
                    vm.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getVideoPage');
                store.dispatch('getVideoItemsSafety').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'video_safety';
        },
        created () {
            document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/video/video-safety.scss';
    @import '@/styles/respond/video/video-respond.scss';
</style>